// tslint:disable-next-line: max-line-length
export const EMAIL_REG_EXP = new RegExp("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]{1,64}?(?:\\.(?:[a-zA-Z0-9-]{2,64}))*$");
export const PASSWORD_REG_EXP = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,50}$/);
